<template>
    <div class="content daily">
        <Back url="/icif" text="首页"/>
        <Loading v-if="loading"/>
        <template v-else>
            <Ques
                :questions="questions"
                @submit="handleSubmit"
            />
        </template>
        <img src="http://guokrapp-static.guokr.com/FmG51Y2z5yeQqJd-kW-WuF-ZoYpE" alt="" class="p2"/>
    </div>
</template>

<script>
import { Loading } from 'vant';
import { objToList, arrRenameKey } from '@/utils/func';
import { cacQuizsGet, cacQuizResultsPost } from '@/apis/cac';
import Ques from './components/Ques'
import Back from '@/components/Back'
// import Analysis from './components/Analysis'
export default {
    components: {
        Ques,
        // Analysis,
        Loading,
        Back
    },
    data() {
        return {
            maxDailyTime: 0,
            loading: true,
            questions:[],
            userResult: {},
            results:[]
        };
    },
    async mounted() {
        this.getQues()
    },
    methods: {
        async getQues() {
            try {
                const {body} = await cacQuizsGet({
                    params: {
                        limit: 5,
                        extra_category: 'extra_sun',
                    }
                })
                console.log(body)
                this.questions = body
                this.loading =false
            } catch (error) {
                console.log(error)
                this.loading =false
                this.$router.replace('/icif')
            }
        },
        async handleSubmit(answers) {
            try {
                const {
                    body
                } = await cacQuizResultsPost({
                    body: {
                        resource: 'sun',
                        user_quizs: arrRenameKey(objToList(answers, 'quiz_id', (val) => parseInt(val)), {seq_id: 'answer_seq_num'})
                    }
                })

                // 跳转至结果页
                this.$router.replace(`/icif/result/${body.result_id}`)
            } catch (error) {
                console.log(error)
                this.$router.replace('/icif')
            }
        },
    }
};
</script>
<style lang="less" scoped>
.daily{
    /deep/.back {
        top: auto;
        left: auto;
        bottom: 0;
        right: 1vw;
        font-size: 3vw;
        opacity: .7;
        z-index: 1;
        width: auto;
        height: 3vw;
        padding: 5vw;
        .icon {
            margin-right: 1vw;
            font-size: 2vw;
        }
    }
    /*控制整个滚动条*/
    ::-webkit-scrollbar {
        background-color: transparent;
    }

    /*滚动条两端方向按钮*/
    ::-webkit-scrollbar-button {
        background-color: transparent;
    }

    /*滚动条中间滑动部分*/
    ::-webkit-scrollbar-thumb {
        background-color: transparent;
    }

    /*滚动条右下角区域*/
    ::-webkit-scrollbar-corner {
        background-color: transparent;
    }
    .content-wrap {
        background-image: url(http://guokrapp-static.guokr.com/Fudvr7yllh2kcXonhok25xlKb3D6);
        background-position: bottom center;
    }
    /deep/.van-loading {
        text-align: center;
    }
    .scroll-content{
        margin-top: auto;
        overflow-x: hidden;
    }
    .p2 {
        position: absolute;
        bottom: 0;
        left: 4vw;
        width: 15vw;
    }
}
</style>
